import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from '../../api/api.service';
import { FILTERS_ENDPOINTS } from '../../api/endpoints/filters.endpoints';

@Injectable({
  providedIn: 'root',
})
export class FiltersService {
  selectedFilter = new BehaviorSubject({});
  currentSelectedFilter = this.selectedFilter.asObservable();
  private api = inject(ApiService);

  getFiltersData(params): Observable<any> {
    return this.api.get(FILTERS_ENDPOINTS.V1.FILTERS_DATA, { params: params });
  }

  saveFilter(param, filterData): Observable<any> {
    return this.api.post(FILTERS_ENDPOINTS.V1.SAVED_FILTERS, filterData, {
      params: param,
    });
  }

  getSavedFilters(params): Observable<any> {
    return this.api.get(FILTERS_ENDPOINTS.V1.SAVED_FILTERS, { params: params });
  }

  deleteSavedFilter(pk): Observable<any> {
    return this.api.delete(FILTERS_ENDPOINTS.V1.SAVED_FILTERS, {
      body: { pk: pk },
    });
  }

  changeSelectedFilter(updateFilter) {
    this.selectedFilter.next(updateFilter);
  }
}
